import { Banner, BaseContent, Button, Icon, Skeleton, useMediaQueryContext, } from '@fourthwall/components';
import { ExclamationMarkIcon } from '@fourthwall/icons';
import React from 'react';
import GoogleAnalyticsImage from './assets/google-analytics.svg';
import * as S from './GoogleAnalytics.styled';
export const GoogleAnalyticsView = ({ title, description, banner, issue, button, }) => (React.createElement(S.Container, null,
    React.createElement(S.Content, null,
        React.createElement("div", null,
            React.createElement("img", { src: GoogleAnalyticsImage, alt: "Google Analytics logo" })),
        React.createElement("div", { style: { display: 'grid', gap: 1 } },
            React.createElement(BaseContent, null,
                React.createElement("strong", null, title)),
            React.createElement(BaseContent, { appearance: "secondary", size: "small" }, description)),
        button && React.createElement(Button, { ...button }),
        issue && (React.createElement(S.Issue, null,
            React.createElement(Icon, { component: ExclamationMarkIcon, height: 16 }),
            issue))),
    banner && React.createElement(Banner, { ...banner })));
const GoogleAnalyticsBarViewSkeleton = () => {
    const media = useMediaQueryContext();
    return (React.createElement(Skeleton, null,
        React.createElement(Skeleton.Shape, { width: "100%", height: media.tablet ? 84 : 243 })));
};
GoogleAnalyticsView.Skeleton = GoogleAnalyticsBarViewSkeleton;
